import { Component, HostListener, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { UserFigureService } from "../../../auth/service/user-figure.service";
import { SkillsService } from "../../../auth/service/skills.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { WorkDomainService } from "../../../auth/service/work-domain.service";
import moment from "moment/moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TutorialService } from "../../../auth/service/tutorial.service";

@Component({
  selector: "app-onboarding-cv-experience",
  templateUrl: "./onboarding-cv-experience.component.html",
  styleUrls: ["./onboarding-cv-experience.component.scss"],
})
export class OnboardingCvExperienceComponent implements OnInit {
  //  Public
  public coreConfig: any;

  public currentUser: any;

  public items_experiences: any = [];

  public today: any = moment().format("DD-MM-YYYY");

  public scrollTop: number = 0;

  public headerHeight: number = 0;

  public new_skill: string = "";

  public skillToPropose: Array<any> = [];

  public indexOfskillToProposeArray: number = 0;

  public skills_list: Array<any> = [];

  public skillWaitingToApprove: Array<any> = [];

  @HostListener("window:scroll", ["$event"])
  windowScrolled() {
    this.scrollTop = window.scrollY;
  }

  /**
     * Constructor
     *
     * @param _router
     * @param {CoreConfigService} _coreConfigService
     * @param {UserFigureService} _userFigureService
     * @param {SkillsService} _skillService

     * @param _utilService
     * @param _userService
     * @param _authenticationService
     * @param _workDomainService
     * @param _modalService
     * @param _tutorialService
     */
  constructor(
    private _router: Router,
    private _coreConfigService: CoreConfigService,
    public _userFigureService: UserFigureService,
    public _skillService: SkillsService,
    public _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    public _workDomainService: WorkDomainService,
    public _modalService: NgbModal,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    const header: any = document.querySelector("header");
    this.headerHeight = header.clientHeight;
    let skillNotApproved: any = [];
    await this._userFigureService.getList();
    await this._skillService.getList();
    await this._workDomainService.getList();
    this.skills_list = this._skillService.list;
    const currentUser = this._authenticationService.getCurrentUser();
    if (currentUser && currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this.currentUser = await this._userService.get(currentUser.hash);

    this.currentUser.experiences.map((exp: any) => {
      /*Aggiungiamo un array vuoto per inserire le skill approvate che l'utente ha inserito nelle sue esperienze*/
      exp.tecnologyApproved = [];
      exp.tecnologyWaitingToApprove = [];
    }); /*Inseriamo le skill approvate nel array*/
    this.currentUser.experiences.map((exp: any, index: number) => {
      if (exp.skill_ids && exp.skill_ids.length > 0) {
        exp.skill_ids.map((skillEmployee: any) => {
          const isAnApprovedSkill: any = this._skillService.list_enabled.find((skill: any) => skill.id === Number(skillEmployee));
          if (isAnApprovedSkill) {
            exp.tecnologyApproved.push(skillEmployee);
            this.currentUser.experiences[index] = exp;
          } else {
            skillNotApproved.push(skillEmployee);
            exp.tecnologyWaitingToApprove.push(skillEmployee);
          }
        });
      }
    });
    /*Per ogni esperienza che l'utente ha salvato in database creiamo un nuovo item in items_experiences*/
    this.currentUser.experiences.map((exp: any) => {
      this.items_experiences.push({
        from: exp.from ? moment(exp.from).format("YYYY-MM-DD") : null,
        to: exp.to ? moment(exp.to).format("YYYY-MM-DD") : null,
        agency: exp.agency ? exp.agency : null,
        description: exp.description ? exp.description : null,
        domain: exp.domain ? exp.domain : null,
        tecnologyApproved: exp.tecnologyApproved ? exp.tecnologyApproved : null,
        tecnology: [],
        tecnologyWaitingToApprove: exp.tecnologyWaitingToApprove ? exp.tecnologyWaitingToApprove : null,
        figure: exp.figure_id ? exp.figure_id : null,
        isCurrentExperience: exp.to ? false : true,
        customer: exp.customer ? exp.customer : null,
      });
    });
    skillNotApproved.map((skill) => {
      /*Qui inseriamo le skill che sono in attesa di approvazione*/
      const skillToApprove = this._skillService.list.find((item) => item.id === skill);
      if (skillToApprove) {
        this.skillWaitingToApprove.push(skillToApprove);
      }
    });

    /*Aggiungiamo un item vuoto*/
    this.addExperienceItem();

    this._utilService.hideLoading();
  }

  /**
   * Add Item
   */
  addExperienceItem() {
    this.items_experiences.push({
      from: "",
      to: "",
      agency: "",
      customer: "",
      description: "",
      domain: "",
      tecnology: [],
      tecnologyApproved: [],
      tecnologyWaitingToApprove: [],
      figure: null,
      isCurrentExperience: false,
    });
  }

  /**
   * DeleteItem
   *
   * @param index
   */
  removeExperienceItem(index: number) {
    /*Oltre a rimuovere l'oggetto specifico del array items_experiences svuotiamo skillToPropose[Array] che contiene soltanto le skill proposte, per poi ripopolarlo*/
    delete this.items_experiences[index];
    this.skillToPropose = [];
    this.items_experiences.map((item) => {
      if (item.tecnologyApproved && item.tecnologyApproved.length > 0) {
        this.skillToPropose.push({
          skill: item.tecnologyApproved.filter((techApproved: any) => typeof techApproved === "string"),
        });
      }
    });
    this.items_experiences = this.items_experiences.filter((i) => i);
    if (this.items_experiences.length == 0) {
      this.addExperienceItem();
    }
  }

  async addModalObjectSkill() {
    /*Funzione per aggiungere una skill al array di skill che l'utente può proporre(skillToPropose)*/
    if (this.new_skill == null) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }

    /*Controllo che la skill non sia già presente nel nostro database*/
    const skillAlreadyExists = this.skills_list.find((skill) => skill.name === this.new_skill.trim());
    if (skillAlreadyExists) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST_IN_DATABASE" });
      this.new_skill = "";
      return false;
    }
    /*Fine Controllo che la skill non sia già presente nel nostro database*/

    /*Controllo che la skill non sia già presente nelle sue skill*/
    let skillAlreadyProposed = false;
    this.items_experiences.map(async (item: any) => {
      if (item.tecnology.includes(this.new_skill)) {
        this.new_skill = "";
        skillAlreadyProposed = true;
      }
    });
    if (skillAlreadyProposed) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      return false;
    }
    /*Fine Controllo che la skill non sia già presente nelle sue skill*/

    this.skillToPropose = []; /*Ogni volta inizializziamo this.skillToPropose per poi popolarlo*/
    /*Aggiungiamo a tecnologyApproved la skill proposta che a differenza delle altre sarà una string proposta dall'utente*/
    this.items_experiences[this.indexOfskillToProposeArray].tecnology.push(this.new_skill);
    this.items_experiences.map((item) => {
      if (item.tecnology) {
        this.skillToPropose.push({
          skill: item.tecnology.filter((tech: any) => typeof tech === "string"),
        });
      }
    });

    /*Resettiamo la variabile new skill*/
    this.new_skill = "";
  }

  public modalOpen(modalBasic, index) {
    this.new_skill = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.indexOfskillToProposeArray = index; /*Salviamo index dell'oggetto this.items_experiences per poi utilizzarla sia per i delete che per l' add delle skill proposte*/
  }

  async save() {
    /*In items inseriremo solo l'esperienze completamente riempite*/
    let items = this.items_experiences.filter((i) => i.from || i.agency || i.description || i.domain || i.figure || i.tecnologyApproved.length > 0 || i.tecnologyWaitingToApprove.length > 0);
    /*Prendiamo le tecnologie di tecnologyApproved e tecnologyWaitingToApprove le mettiamo in tecnology e rimuoviamo i possibili doppioni*/
    items.map((item: any, index) => {
      items[index].tecnology = items[index].tecnology.concat(item.tecnologyApproved).concat(item.tecnologyWaitingToApprove);
      items[index].tecnology = items[index].tecnology.filter(function (value: any, pos: number, self: any) {
        return self.indexOf(value) == pos;
      });
    });
    let showedError: boolean = false;
    if (!items || items.length === 0) {
      showedError = false;
    } else if (items.length > 0) {
      items.map(async (exp: any) => {
        if (
          /*In caso l'esperienza non sia corrente teniamo conto della variabile exp.to come obbligatoria*/
          exp.isCurrentExperience &&
          !!exp.from &&
          !!exp.to &&
          !!exp.agency &&
          !!exp.description &&
          !!exp.domain &&
          !!exp.figure &&
          exp.tecnology.length < 1 &&
          !showedError
        ) {
          showedError = false;
        }
        if (
          /*In caso l'esperienza sia corrente non teniamo conto della variabile exp.to come obbligatoria*/
          ((!exp.isCurrentExperience && !exp.to) || !exp.from || !exp.agency || !exp.description || !exp.domain || !exp.figure || exp.tecnology.length < 1) &&
          !showedError
        ) {
          showedError = true;
          await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_FIELDS_EMPTY" });
        }
      });
    }
    if (showedError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_FIELDS_EMPTY" });
      return false;
    }

    let itemToSend: any = [];
    itemToSend = items;

    /*Cancelliamo isCurrentExperience, tecnologyApproved e tecnologyWaitingToApprove da tutti gli oggetti dell' array in quanto al backend sono dati superflui*/
    itemToSend = itemToSend.map(({ isCurrentExperience, tecnologyApproved, tecnologyWaitingToApprove, ...rest }) => ({ ...rest }));

    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, { experiences: itemToSend })
      .then(() => this._router.navigateByUrl("/onboarding/skills"))
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
